/**
 * Provide configuration settings
 */
import { Dispatch, SetStateAction, createContext, useContext } from "react";
import { ClaimUser } from "../models/authorize.model";
import {
  FilterModel,
  ReportDataModel,
  ReviewsContext,
} from "../models/report.model";

export interface Config {
  loggedUser?: ClaimUser;
  setLoggedUser: Dispatch<SetStateAction<ClaimUser | undefined>>;
  filter?: FilterModel;
  setFilter: Dispatch<SetStateAction<FilterModel | undefined>>;
  data?: ReportDataModel;
  reviews?: ReviewsContext;
  setReviews: Dispatch<SetStateAction<ReviewsContext | undefined>>;
  localized: (key: string) => string;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
}

export const ConfigContext = createContext<Config | undefined>(undefined);

export function useConfig(): Config {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error("Configuration context not initialized!");
  }
  return config;
}
